import DeleteDocumentPopup from './DeleteDocumentPopup';

export default DeleteDocumentPopup;
